// extracted by mini-css-extract-plugin
module.exports = {"dot1":"LoadingIcon_dot1__elcbR","grow":"LoadingIcon_grow__onXeZ","dot2":"LoadingIcon_dot2__23Jbv","dot3":"LoadingIcon_dot3__2FiJj","infotext":"LoadingIcon_infotext__27IVM"};